const React = require('react');

const SendIcon = () => (
  <svg width={21} height={15} fill="currentColor">
    <path d="M20.746 6.996L11.372.122a.626.626 0 0 0-.995.504v3.77c-5.333.327-7.629 3.788-9.327 7.863-.23.55.374 1.08.888.783 2.528-1.446 4.549-2.417 8.439-2.417v3.75c0 .523.595.8.994.504l9.374-6.874a.626.626 0 0 0 0-1.009z" />
  </svg>
);

module.exports = SendIcon;
